import api from './api';

export interface TagItem {
  id: string;
  tag_name: string;
  tag_values: string[];
  description: string | null;
  is_active: boolean;
  is_default: boolean;
  created_at: string | null;
  updated_at: string | null;
  vector_count?: number | null;
}

export interface TagStats {
  total_vectors: number;
  dimension: number;
  tag_count: number;
  tags: Array<{
    id: string;
    tag_name: string;
    tag_values: string[];
    vector_count: number;
    is_default: boolean;
  }>;
}

export interface CreateTagRequest {
  tag_name: string;
  tag_values: string[];
  description?: string | null;
}

export interface UpdateTagRequest {
  tag_name?: string;
  tag_values?: string[];
  description?: string | null;
  is_active?: boolean;
}

export const tagService = {
  listTags: async (params?: { is_active?: boolean }): Promise<TagItem[]> => {
    const query = new URLSearchParams();
    if (params?.is_active !== undefined) query.set('is_active', String(params.is_active));
    const qs = query.toString();
    const response = await api.get<TagItem[]>(`/api/tags${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  getTag: async (id: string): Promise<TagItem> => {
    const response = await api.get<TagItem>(`/api/tags/${id}`);
    return response.data;
  },

  createTag: async (data: CreateTagRequest): Promise<TagItem> => {
    const response = await api.post<TagItem>('/api/tags', data);
    return response.data;
  },

  updateTag: async (id: string, data: UpdateTagRequest): Promise<TagItem> => {
    const response = await api.put<TagItem>(`/api/tags/${id}`, data);
    return response.data;
  },

  deleteTag: async (id: string): Promise<any> => {
    const response = await api.delete(`/api/tags/${id}`);
    return response.data;
  },

  deleteTagPermanent: async (id: string): Promise<any> => {
    const response = await api.delete(`/api/tags/${id}/permanent`);
    return response.data;
  },

  setDefault: async (id: string): Promise<TagItem> => {
    const response = await api.post<TagItem>('/api/tags/set-default', {
      tag_id: id,
    });
    return response.data;
  },

  getStats: async (): Promise<TagStats> => {
    const response = await api.get<TagStats>('/api/tags/stats');
    return response.data;
  },

  getFileVectorCounts: async (): Promise<Record<string, number>> => {
    const response = await api.get('/api/documents/vector-counts');
    return response.data.file_vector_counts;
  },
};
